"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAGINATION_DELAY = exports.DEFAULT_PAGE_SIZE = exports.ARTICLES_SECTION = void 0;
const ARTICLES_SECTION = exports.ARTICLES_SECTION = 'articles-section';
const DEFAULT_PAGE_SIZE = exports.DEFAULT_PAGE_SIZE = 12;
const PAGINATION_DELAY = exports.PAGINATION_DELAY = 500;
